import { initBotId } from 'botid/client/core';

initBotId({
  protect: [
    {
      path: '/api/billing/referral-code',
      method: 'GET',
    },
    {
      path: '/api/billing/checkout-setup',
      method: 'POST',
    },
    {
      path: '/api/billing/record-consent',
      method: 'POST',
    },
    {
      path: '/api/billing/save-address',
      method: 'POST',
    },
    {
      path: '/api/billing/add-sport-quote',
      method: 'POST',
    },
    {
      path: '/api/billing/add-sport',
      method: 'POST',
    },
  ],
});

// PostHog init is deliberately NOT here. Module-eval runs before React
// hydration; posthog.init injects the array.js loader <script> as
// `insertBefore(loader, document.scripts[0])`, which displaces SSR'd <script>
// tags (eg. our JsonLd) and triggers a hydration mismatch
// (https://github.com/PostHog/posthog-js/issues/1645). Init now lives in
// `lib/posthog/init.ts` as ensurePostHogInit() and is called lazily from the
// useEffects / handlers in components/posthog/PostHogClient.tsx and
// lib/posthog/events.ts.
